import { defineMessages, useIntl } from 'react-intl';

export const useOfferHeader = () => {
  const { formatMessage } = useIntl();
  return formatMessage(messages.rewardsAndOffers);
};
const messages = defineMessages({
  rewardsAndOffers: {
    id: 'rewardsAndOffers',
    defaultMessage: 'Rewards And Offers',
    description: 'Rewards and offers headings',
  },
});
